import { render, staticRenderFns } from "./MarketingIndex.vue?vue&type=template&id=a23302b2&scoped=true&"
import script from "./MarketingIndex.vue?vue&type=script&lang=js&"
export * from "./MarketingIndex.vue?vue&type=script&lang=js&"
import style0 from "./MarketingIndex.vue?vue&type=style&index=0&id=a23302b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23302b2",
  null
  
)

export default component.exports